import Vue from "vue";
import Vuex from "vuex";
import httpService from "@/utils/service";
import COVER from "@/utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import {shareTitle, getLocationPoint, getBaiduLocation} from "@/utils/utils";
import {
    getNotice,
    getRelate,
    queryChat,
    userLog,
    setUser,
    setPosition,
    queryComment,
    discussNews,
    discussNewsOther,
    getHotTopic,
    getHotTopicDesc,
    getHotTopicNews,
    getHotNews,
    getSceneCommon,
    queryMultiProgress,
    queryPoke,
    getSceneMultiProcess,
    queryTourism,
    queryTourSight,
    queryTourDetail,
    queryTourGo,
    queryTourCommon,
    queryAudio,
    queryAudioList,
    queryXimalayaList,
    enterAudio,
    audioAndPlay,
    queryAudioBtn,
    queryAudioSearch,
    queryAudioScene,
    getActivityList,
    getFakeUser,
    getActivityScene,
    shareActivity,
    getQRCode,
    exitfeedback,
    feedbackSublist,
    feedbackData,
} from "@/api/data";
import {tourData, recomData, clickBtn, selectArea, noInter, musicItem, createItem, activity, activityDetail, quickClick, ximalayaAudio, ximalayaCreateItem, activityButton, QRcode, CarCard, movies, stock, tuiwan, faq, watch} from "@/utils/demo";
import audio from './audio'

const share = shareTitle();
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // aid: process.env.VUE_APP_ENV == "test" ? "5d90661929dcaa0b2d6ce760" : "5e69b4d1877710001edb7cb2", //活动id
        isApp: false, //是否在app中
        isPC: false, //是否在PC端
        versionSize: 0, //app版本
        serverTime: 0, // 服务器时间
        userinfo: {}, //用户信息
        shareData: { //分享信息
            title: share.title,
            desc: share.desc,
            imgUrl: "https://wapcdn.thecover.cn/wap/2.3.4/share_logo.png",
            link: window.location.origin + window.location.pathname
        },
        isImmerse: false, //是否沉浸式
        device: COVERAPP.Attribute.isIOS() ? "ios" : "android",
        maskData: null, //弹框信息
        globalDuration: 0,
        chatLoading: false,
        maskShowStatus: false,
        homeChat: [],
        noticeList: [],
        toastList: [],
        linkSrc: "",
        isClearTimer: true,
        view11Tips: "",  //解决ios11布局问题,
        toastContent: {toastType: 0, list: {name: "", content: ""}},   // toastType:0 内容多提示类  1:选择地点类 选择价格类  2.选择景点类型类 3.导航 4.地点介绍   5.附近美食  6.附近景点  list:{}  name 左上角名称 content:''  or [],
        isToastShow: false,
        readNewsId: "",
        isOpenChat: false, //开启聊新闻模式,
        OpenChatID: 0,//0新增新闻模式聊天，1标识功能反馈聊天
        isInputShow: true,
        isClearInitTimer: false,  //该变量用来设置用户默认信息 如果未得到授权,
        newsContent: {},
        questionTips: "",
        guideTips: "",
        isViewFade: false,
        isTourShow: false,

        selectList: [],
        tourSelectData: [],

        tagsList: [],
        tourSelectType:'',

        xmly: null,

        isAudioShow: false,
        isAudioBarShow: true,
        audioSelectData: [],

        isUserShow: false,
        fakeUserList: [],

        isPlayAudio: false,
        showPicTop: false,
        shareId: 0, //分享的id
        shareShowData: {}, //分享具体内容
        feedbackDirection: "",//功能反馈一级按钮名称
        feedbackType: "",//功能反馈二级按钮名
    },
    modules: {
        audio: audio
    },
    mutations: {
        setPlayAudio(state, data){
            state.isPlayAudio = data
        },
        // 设置是否在app中
        appFlag(state, flag) {
            state.isApp = flag;
        },
        IsPC(state, data){
            const userAgentInfo = navigator.userAgent
            const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
            let flag = true;
            for (let v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0 || 'ontouchend' in document) {
                    flag = false;
                    break;
                }
            }
            state.isPC = flag
        },
        setVersionSize(state, num) {
            state.versionSize = num;
        },
        setServerTime(state, time) {
            state.serverTime = time;
        },
        setToastData(state, data) {
            state.toastData = data;
        },
        setPageLoading(state, flag) {
            state.pageLoading = flag;
        },
        setIsImmerse(state, flag) {
            state.isImmerse = flag;
        },

        // 设置用户信息
        getUserinfo(state, data) {
            state.userinfo = data;
        },
        // 设置分享数据
        setshareData(state, data) {
            state.shareData = data;
        },
        // 设置弹窗数据
        setMaskData(state, data) {
            state.maskData = data;
        },
        // 设置获得红包弹窗是否显示
        sethbFlagData(state, data) {
            state.hbFlagData = data;
        },
        // 设置结果页数据
        setResultData(state, data) {
            state.resultData = data;
        },
        /*我的*/
        setViewFade(state, data) {
            if (!data) {
                state.isViewFade = data;
            } else {
                setTimeout(() => {
                    state.isViewFade = data;
                }, 300);
            }

        },
        setHomeData(state, data) {
            state.homeChat = data;
        },
        setNoticeData(state, data) {
            state.noticeList = data;
            state.maskShowStatus = false;
        },
        setAudioSelectData(state, data){
            state.audioSelectData = data
        },
        setToastList(state, data) {
            state.toastList = data;
            state.maskShowStatus = false;
        },
        setGuideTips(state, data) {
            state.guideTips = data;
        },
        setXmly(state, data){
            state.xmly = data
        },
        setAudioShow(state, data){
            state.isAudioShow = data;
        },
        contactDisData(state, data) {
            state.homeChat = [];
            if (data.length == 1 && data[0].content.right) {
                // let questionTips = data[0].content.tips.replace(/(\r\n|\n|\r)/gm, "<br />")
                state.questionTips = data[0].content.tips
            } else {
                let count = 0;
                if (!data[0].content.right) {
                    if (data[0].content.view == 100) {
                        state.guideTips = data[count].content.tips;
                    }
                    if (data[0].content.view !== 100) {
                        state.guideTips = "";
                    }
                    if (data[data.length - 1].content.view == 101) {
                        state.isTourShow = true;
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                        state.tourSelectType=data[data.length - 1].content.list.value;
                    }
                    if (data[data.length - 1].content.view !== 101) {
                        state.isTourShow = false;
                        state.tourSelectType='';
                    }
                    if (data[data.length - 1].content.view == 104) {
                        state.isAudioShow= true
                        state.isInputShow = true
                        state.isAudioBarShow = false
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                    }
                    if (data[data.length - 1].content.view !== 104) {
                        state.isAudioShow = false
                    }
                    if (data[data.length - 1].content.view == 105) {
                        state.isInputShow = false
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                        if(data[data.length - 1].content.list.value === 'activityList'){
                            state.isUserShow = true
                        } else {
                            state.isUserShow = false
                        }
                    }
                    if (data[data.length - 1].content.view !== 105) {
                        state.isUserShow = false
                        state.isInputShow = true
                    }
                    if(data.length>=2){
                        if(data[1].content.view==15){
                            state.isInputShow=false;
                            setTimeout(()=>{ state.isClearTimer=true;},100)
                        }
                    }
                         //输入宽以及按钮都不展示 
                         const isInputNotShow = data.findIndex(value => value.content.view === 102 )
                         if (isInputNotShow !== -1) { state.isInputShow = false; setTimeout(() => { state.isClearTimer = true; }, 100) }
                         //展示
                         const isInputShow = data.findIndex(value => value.content.view === 103)
     
                         if (isInputShow !== -1) { state.isInputShow = true; }


                    state.homeChat = [...state.homeChat, ...data];

                    setTimeout(() => {
                        state.maskShowStatus = false;
                        state.isViewFade = true;
                        httpService.pageScrollTo();
                    }, 0);
                }
            }


        },
        removeSyncLeftData(state, data) {
            // state.homeChat
        },
        //聊新闻使用
        chatDisData(state, data) {
            if (data.isClear) {
                state.homeChat = [];
            }
        },

        setLinkSrc(state, data) {
            state.linkSrc = data;
        },
        setGlobalDuration(state, data) {
            state.globalDuration = data;
        },
        setChatLoading(state, data) {
            state.chatLoading = data;
        },
        setClearTimer(state, data) {
            state.isClearTimer = data;
        },
        setToastContent(state, data) {
            state.toastContent = data;
        },
        setToastShow(state, data) {
            state.isToastShow = data;
            document.getElementById('contentTips').scrollTop=0
        },
        setReadNewsId(state, data) {
            state.readNewsId = data;
        },
        setOpenChat(state, data) {
            state.isOpenChat = data;
        },
        setOpenChatID(state, data) {
            state.OpenChatID = data;
        },
        setInputShow(state, data) {
            state.isInputShow = data;
        },
        setTourShow(state, data) {
            state.isTourShow = data;
        },
        setUserShow(state, data) {
            state.isUserShow = data;
        },
        setInitTimer(state, data) {
            state.isClearInitTimer = data;
        },
        setNewsContent(state, data) {
            state.newsContent = data;
        },
        setMaskShowStatus(state, data) {
            state.maskShowStatus = data;
        },
        setSelectList(state, data) {
            state.selectList = data;
        },
        setTourSelectData(state, data) {
            state.tourSelectData = data;
        },
        setTagsList(state, data) {
            if (data.length) {
                const list = state.tagsList;
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            } else {
                /*当传进来的为[]时重置*/
                state.tagsList = [];
            }
        },
        setSingleTags(state, data) {
            const list = state.tagsList;
            if (data.length) {
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    list.splice(list.findIndex(v => v.name.indexOf("km") > 0), 1);
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            }
        },

        setAudioBarShow(state, data){
            state.isAudioBarShow = data;
        },
        setFakeUserList(state, data){
            state.fakeUserList = data;
        },
        setShowShareData(state, data) {
            state.shareShowData = data
        },
        setshareId(state, data) {
            state.shareId = data
        },
        SetFeedbackDirection(state, data) {
            state.feedbackDirection = data
        },
        SetFeedbackType(state, data) {
            state.feedbackType = data
        },
        setShowPicTop(state, data) {
            state.showPicTop = data
        },

    },
    actions: {
        // 设置是否在app中
        appFlagAsync({commit, state}, flag) {
            commit("appFlag", flag);
        },
        setVersionSizeAsync({commit, state}, num) {
            commit("setVersionSize", num);
        },
        setServerTimeAsync({commit, state}, time) {
            commit("setServerTime", time);
        },

        // 获取用户信息
        getUserInfoAsync({dispatch, commit, state}) {
            COVER.getUser((ret) => {
                // setTimeout(()=>{   commit("setInitTimer",true)},100)
                const userinfo = JSON.parse(JSON.stringify(ret));
                if (COVERAPP.Attribute.isIOS() && userinfo.token) {
                    if (parseInt(state.versionSize) >= 450) {
                        userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
                    }
                }
                userLog({position: "store拿到返回", ...ret});

                commit("getUserinfo", userinfo);

                setUser(userinfo).then((res) => {
                    const {data: {data}} = res;
                    sessionStorage.setItem("USER_ID", data.id);
                    // cio.setUser(data.id,  ret.nickname, {userInfo: JSON.stringify(ret)});
                    const id = sessionStorage.getItem("USER_ID");
                    if (id || state.userinfo.id) {
                        commit("setInitTimer", true);
                        commit("chatDisData", {isClear: []});
                        getBaiduLocation()
                        dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                            commit("setClearTimer", false);
                        });
                        dispatch("fetchNotice");
                        dispatch("queryTourism");
                        dispatch("queryAudio")
                        // getLocationPoint().then((res) => {
                        //     setPosition(res);
                        // });
                    }

                });
                // userLog(JSON.parse(JSON.stringify(res)))
            });

        },
        // 设置分享数据
        setshareDataAsync({commit, state}, data) {
            commit("setshareData", data);
        },
        // 设置弹窗数据
        setMaskDataAsync({commit, state}, data) {
            commit("setMaskData", data);
        },
        setToastDataAsync({commit, state}, data) {
            commit("setToastData", data);
        },
        setPageLoadingAsync({commit, state}, flag) {
            commit("setPageLoading", flag);
        },
        setIsImmerseAsync({commit, state}, flag) {
            commit("setIsImmerse", flag);
        },
        /*这设置用户信息*/
        setNoInfo({dispatch, state, commit}) {
            const userinfo = {origin: "yk", sessionId: COVER.uuid("uid")};
            commit("getUserinfo", userinfo);
            return new Promise((resolve, reject) => {
                try {
                    setUser(userinfo).then((res) => {
                        const {data: {data}} = res;
                        sessionStorage.setItem("USER_ID", data.id);
                        const id = sessionStorage.getItem("USER_ID");

                        if (id || state.userinfo.id) {
                            commit("chatDisData", {isClear: []});
                            dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                                commit("setClearTimer", false);
                                dispatch("fetchNotice");
                            });

                            getBaiduLocation();
                            // getLocationPoint().then((res) => {
                            //     setPosition(res);
                            // });
                        }

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        /*我的逻辑*/
        //首页
        fetchHome({state, dispatch, commit}, {payload}) {
           if(payload.noInput && !state.isTourShow){
               commit("setInputShow",false);
           } else {
               commit("setInputShow", true);
           }
            commit("setOpenChat", false);
            commit("setOpenChatID", 0);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        if(data[data.length - 1].content.view === 105 && data[data.length - 1].content.list.value === 'activityList'){
                            dispatch("getFakeUser").then(()=>{
                                commit("contactDisData", data);
                                commit("setGlobalDuration", 0);
                                if(!(payload.hasClearTimer)){
                                    commit("setClearTimer", false);
                                }
                            })
                        } else {
                            commit("contactDisData", data);
                            commit("setGlobalDuration", 0);
                            if(!(payload.hasClearTimer)){
                                commit("setClearTimer", false);
                            }
                        }
                        resolve(data);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //请求question接口不拿返回数据
        fetchHomeNoData({state, commit}, {payload}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
 commit("setOpenChatID", 0);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setGlobalDuration", 0);
                        if(!(payload.hasClearTimer)){
                            commit("setClearTimer", false);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*戳一戳*/
        queryPoke({state, commit}) {
            commit("setInputShow", true);
            commit("setUserShow", false)
            commit("setOpenChat", false);
 commit("setOpenChatID", 0);
            cio.track(3, "click", "pock");
            return new Promise((resolve, reject) => {
                try {
                    queryPoke().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            })
        },


        //多流程
        queryMultiProgress({state, commit}, {payload}) {
            commit("setInputShow", false);
            commit("setOpenChat", false);
 commit("setOpenChatID", 0);
            return new Promise((resolve, reject) => {
                try {
                    queryMultiProgress(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        //相关问题
        fetchRelate({commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    getRelate(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setToastList", data);
                        // commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        //提示栏
        fetchNotice({commit}) {
            getNotice().then((res) => {
                const {data} = res.data;
                commit("setNoticeData", data);
            });
        },

        //聊新闻
        queryComment({commit}, {payload}) {
            commit("setInputShow", false);
            commit("setChatLoading", true);
            commit("setTourShow",false)
            return new Promise((resolve, reject) => {
                try {
                    queryComment(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setClearTimer", true);
                        commit("setChatLoading", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        discussNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);
 commit("setOpenChatID", 0);

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        discussNewsOther({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNewsOther(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopic({state, commit}) {
            commit("setInputShow", true);
            commit("contactDisData", [{content: {right: true, tips: ""}}]);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopic().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        // commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicDesc({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicDesc(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotNews({state, commit}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotNews().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);
 commit("setOpenChatID", 0);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneCommon().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneMultiProcess({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneMultiProcess().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*旅游场景--------------------*/
        queryTourism({state, commit}) {

            return new Promise((resolve, reject) => {
                try {
                    queryTourism().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setSelectList", data);
                        // commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getTourData({state, commit}, {payload}) {
            // commit("setInputShow", true);
            const tags = [];

            const {tagsList} = state;
            tagsList.map((item) => {
                tags.push(item.name);
            });

            return new Promise((resolve, reject) => {
                try {
                    queryTourSight({ tags}).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*根据景点ID请求景点详情*/
        getTourInfo({state, commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    queryTourDetail(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        // commit("setTourShow", false);
                        commit("setClearTimer", true);
                        commit("setInputShow", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*我想去这里玩*/
        getWantToInfo({state, commit}, {payload}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourGo(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", false);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        /*不感兴趣*/
        getTourCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourCommon().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        //听生活频道
        queryAudio({state, commit }) {
            // commit("setChatLoading", true);
            return new Promise((resolve, reject) => {
                try {
                    queryAudio().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        // commit("setChatLoading", false);
                        commit("setAudioSelectData", data)
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        //获取封面播放列表
        queryAudioList({state, commit}, {payload}){
            return new Promise((resolve, reject) => {
                try {
                    queryAudioList(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        // 获取喜马拉雅播放列表
        queryXimalayaList({state, commit}, {payload}){
            return new Promise((resolve, reject) => {
                try {
                    queryXimalayaList(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //边听边玩
        asyncAudioAndPlay({commit}){
            commit("setChatLoading", true);
            return new Promise((resolve, reject) => {
                try {
                    audioAndPlay().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setChatLoading", false);
                        commit("contactDisData", data);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    console.log(error)
                }
            })
        },

        // 看看其他栏目 音频按钮
        queryAudioBtn({commit}, {payload}){
            commit("setChatLoading", true);
            return new Promise((resolve, reject) => {
                try {
                    queryAudioBtn(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setChatLoading", false);
                        commit("contactDisData", data);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    console.log(error)
                }
            })
        },
        queryAudioSearch({commit}, {payload}){
            return new Promise((resolve, reject) => {
                try {
                    queryAudioSearch(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    console.log(error)
                }
            })
        },
        // 喜马拉雅回传接口
        asyncGetCallBack({state, commit}, {payload}){
            return new Promise((resolve, reject) => {
                // 创建实例
                const url = 'https://api.ximalaya.com/openapi-collector-app/album_browse_records'
                // 获取分类列表
                state.xmly.post(url, {browse_records: JSON.stringify(payload)}).then(res => {
                    if (res.code === 0) {
                        // 成功逻辑（仅成功时 code 为 0）
                    }
                }).catch(error => {
                    console.log(error)
                })
            })
        },

        //重进生活场景
        asyncEnterAudio({commit}){
            return new Promise((resolve, reject)=>{
                try {
                    enterAudio().then((res) => {

                    }).catch(err => console.log(err))
                } catch (error) {

                }
            })
        },

        queryAudioScene({commit}){
            commit("setChatLoading", true);
            return new Promise((resolve, reject) => {
                try {
                    queryAudioScene().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setChatLoading", false);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //获得活动列表
        getActivityList({dispatch, commit}){
            return new Promise((resolve, reject) => {
                try {
                    getActivityList().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        dispatch("getFakeUser").then(()=>{
                            commit("contactDisData", data);
                            commit("setGlobalDuration", 0);
                            commit("setClearTimer", true);
                        })
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            })
        },
        //活动假用户
        getFakeUser({commit}){
            return new Promise((resolve, reject) => {
                try {
                    getFakeUser().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setFakeUserList", data)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            })
        },
        //活动不感兴趣接口
        getActivityScene({commit}){
            commit("setChatLoading", true);
            return new Promise((resolve, reject) => {
                try {
                    getActivityScene().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setChatLoading", false);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //分享活动
        shareActivity({commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    shareActivity(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //获得活动二维码
        getQRCode({commit}, {payload}){
            return new Promise((resolve, reject) => {
                try {
                    getQRCode(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
             // 退出功能反馈场景
             exitFeedbackAsync({ state, commit }) {
                //if (payload.noInput && !state.isTourShow) {
                //    commit("setInputShow", false);
                //} else {
                //    commit("setInputShow", true);
                //}
                // console.log("payload===",payload)
                commit("setInputShow", true);
                commit("setOpenChat", false);
                commit("setOpenChatID", 0)
                return new Promise((resolve, reject) => {
                    try {
                        exitfeedback().then((res) => {
                            const { data } = res.data;
                            //console.log(data);
                            resolve(data);
    
                            commit("contactDisData", data);
                            commit("setGlobalDuration", 0);
    
                            commit("setClearTimer", false);
    
                        }).catch(err => {
                            reject(err);
                        });
                    } catch (error) {
                        reject(error);
                    }
                });
            },
            // 获取子目录场景
            feedbackSublistAsync({ state, commit }, { payload }) {
                //if (payload.noInput && !state.isTourShow) {
                //    commit("setInputShow", false);
                //} else {
                //    commit("setInputShow", true);
                //}
                // console.log("payload===",payload)
                commit("setInputShow", true);
                commit("setOpenChat", false);
                commit("setOpenChatID", 0)
                return new Promise((resolve, reject) => {
                    try {
                        feedbackSublist(payload).then((res) => {
                            const { data } = res.data;
                            //console.log(data);
                            resolve(data);
    
                            commit("contactDisData", data);
                            commit("setGlobalDuration", 0);
                            if (!(payload.hasClearTimer)) {
                                commit("setClearTimer", false);
                            }
                        }).catch(err => {
                            reject(err);
                        });
                    } catch (error) {
                        reject(error);
                    }
                });
            },
            // 功能反馈
            feedbackDataAsync({ state, commit }, { payload }) {
                //if (payload.noInput && !state.isTourShow) {
                //    commit("setInputShow", false);
                //} else {
                //    commit("setInputShow", true);
                //}
                // console.log("payload===",payload)
                commit("setInputShow", true);
                commit("setOpenChat", false);
                return new Promise((resolve, reject) => {
                    try {
                        feedbackData(payload).then((res) => {
                            const { data } = res.data;
                            //console.log(data);
                            resolve(data);
    
                            commit("contactDisData", data);
                            commit("setGlobalDuration", 0);
                            if (!(payload.hasClearTimer)) {
                                commit("setClearTimer", false);
                            }
                        }).catch(err => {
                            reject(err);
                        });
                    } catch (error) {
                        reject(error);
                    }
                });
            },
    },
});
